module.exports = __webpack_public_path__ + "img/shopee.809f079.png";